export const ri = (min: number, max: number) => Math.floor(Math.random() * (max - min + 1)) + min;

export const distinct = (avoid: number[], min: number, max: number) => {
  let v: number;
  let tries = 0;
  do {
    v = ri(min, max);
    tries++;
  } while (avoid.includes(v) && tries < 1000);
  return v;
};

/**
 * Format leaderboard timestamps coming either as:
 *  - Unix seconds (number)
 *  - Unix ms (large number)
 *  - ISO string (e.g. "2025-11-11T22:18:39Z")
 */
export function formatLeaderboardDate(at: number | string): string {
  if (at === null || at === undefined) {
    return '-';
  }

  let date: Date;

  if (typeof at === 'number') {
    // If it looks like "seconds" (10 digits-ish), multiply; if it's large, assume ms
    if (at < 1e12) {
      date = new Date(at * 1000);
    } else {
      date = new Date(at);
    }
  } else {
    date = new Date(at);
  }

  if (isNaN(date.getTime())) {
    return '-';
  }

  return date.toLocaleDateString();
}
